import { Badge, Box, HStack, Text, VStack } from '@elkaso-app/web-design';
import React from 'react';

export interface QuotaInfoCellProps {
  quota: number;
  remaining: number;
  used: number;
  usagePercentage: string;
}

export const QuotaInfoCell: React.FC<QuotaInfoCellProps> = ({ quota, remaining, used, usagePercentage }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <VStack align='start' spacing={2} maxW='100%'>
      <HStack spacing={3}>
        <Box>
          <Text fontSize='xs' color='gray.500' fontWeight='medium'>
            Total
          </Text>
          <Text fontWeight='semibold' fontSize='lg' color='blue.600'>
            {quota}
          </Text>
        </Box>
        <Box>
          <Text fontSize='xs' color='gray.500' fontWeight='medium'>
            Used
          </Text>
          <Text fontWeight='semibold' fontSize='lg' color='orange.600'>
            {used}
          </Text>
        </Box>
        <Box>
          <Text fontSize='xs' color='gray.500' fontWeight='medium'>
            Remaining
          </Text>
          <Text fontWeight='semibold' fontSize='lg' color='green.600'>
            {remaining}
          </Text>
        </Box>
      </HStack>
      <Badge
        colorScheme={parseFloat(usagePercentage) > 80 ? 'red' : parseFloat(usagePercentage) > 50 ? 'orange' : 'green'}
        variant='subtle'
        size='sm'>
        Usage: {usagePercentage}
      </Badge>
    </VStack>
  </div>
);
